import { AnnualIncreaseType } from "@fartherfinance/frontend/api/FinancialPlans/types";

export const formatAnnualIncrease = (
  type: AnnualIncreaseType,
  amount: string | undefined
) => {
  if (type === "CustomInflation" && amount === undefined) {
    throw new Error("The value for Custom Inflation cannot be undefined");
  }

  return type === "CustomInflation"
    ? {
        type,
        value: amount ?? "0",
      }
    : { type };
};
